import { useEffect, useState } from "react";
import api from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";
import { TableShell, Th, Td, EmptyRow } from "@/components/admin/DataTable";

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <AdminLayout title="Audit Logs">
      <TableShell>
        <thead className="border-b border-border bg-secondary/40"><tr><Th>Date/Time</Th><Th>User</Th><Th>Role</Th><Th>Action</Th><Th>Module</Th><Th>Record</Th><Th>Detail</Th></tr></thead>
        <tbody className="divide-y divide-border">
          {items.length === 0 ? <EmptyRow colSpan={7} /> : items.map((a) => (
            <tr key={a.id} className="hover:bg-secondary/30" data-testid={`audit-row-${a.id}`}>
              <Td className="text-xs">{new Date(a.created_at).toLocaleString()}</Td>
              <Td className="font-medium">{a.username || "—"}</Td><Td className="capitalize text-xs">{(a.role || "").replace(/_/g, " ")}</Td>
              <Td><span className="rounded-full bg-accent px-2 py-0.5 text-xs font-semibold capitalize text-accent-foreground">{a.action}</span></Td>
              <Td className="capitalize">{a.module}</Td><Td className="font-mono text-xs">{(a.record_id || "").slice(0, 8) || "—"}</Td>
              <Td className="text-xs text-muted-foreground">{a.detail || "—"}</Td>
            </tr>
          ))}
        </tbody>
      </TableShell>
    </AdminLayout>
  );
}
